export default __webpack_public_path__ + "static/media/openpay.1f9eaa99.png";